import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class RemovePolyCoordinateAction extends AbstractProvidedClass {
    constructor(provider, element, index) {
        super(provider);

        this.element = element;
        this.index = index;

        const coord = element.coordinates[index];
        this.savedAbsX = coord.absX;
        this.savedAbsY = coord.absY;
    }

    finish() {
        this.element.removeCoordinate(this.index);
        this.provider.actions.finish();
    }

    undo() {
        this.element.insertCoordinate(this.index, this.savedAbsX, this.savedAbsY);
    }

    redo() {
        this.element.removeCoordinate(this.index);
    }
}
